import type { CSSProperties, ReactNode } from 'react';

/** Colours come from the host's design tokens; the fallbacks keep AA contrast without them. */
const BADGE: CSSProperties = {
  display: 'inline-block',
  padding: '0.125rem 0.5rem',
  borderRadius: 'var(--radius-sm, 0.5rem)',
  background: 'var(--color-badge-bg, light-dark(#fef3c7, #78350f))',
  color: 'var(--color-badge-text, light-dark(#78350f, #fef3c7))',
  fontSize: 'var(--text-sm, 0.875rem)',
  fontWeight: 600,
  lineHeight: 1.4,
};

export function Badge({ children }: { children: ReactNode }) {
  return (
    <span data-badge="" style={BADGE}>
      {children}
    </span>
  );
}
